<div class="min-h-screen">
  <app-block-list [blockIdList]="body"></app-block-list>
  <router-outlet></router-outlet>
</div>
